import React from 'react';
import axios from 'axios';
import moment from 'moment';
// import FromToDateForm from "../../components/Forms/FromToDateForm";
import { Pie } from "react-chartjs-2";
import { ControlLabel, FormControl } from 'react-bootstrap';

class SpecialStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment('2017-09-01T00:00:00.000Z'),
      endDate: moment(),
      specials: null,
      activeSpecial: 'all',
      loaded: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.handleChangeSpecial = this.handleChangeSpecial.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.state.loaded) {
      this.getSpecialStats();
      this.setState({
        loaded: true,
      });
    }
  }

  handleChangeStart(date) {
    this.setState({ startDate: date })
  }

  handleChangeEnd(date) {
    this.setState({ endDate: date })
  }

  handleSubmit(event) {
    event.preventDefault();
    this.getSpecialStats();
  }

  getSpecialStats() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      },
      params: {
        cache: true,
      }
    };

    axios.get(this.props.api.stats.specialStats, config)
      .then((response) => {
        if (!this._calledComponentWillUnmount) {
          this.setState({
            specials: response.data
          });
        }
      }).catch(function (error) {
      console.error('Error axios:', error);
    });
  }

  handleChangeSpecial(event) {
    this.setState({
      activeSpecial: event.target.value,
    });
  }

  render() {
    const { activeSpecial, specials } = this.state;

    const allSpecials = { correctOnFirst: 0, correct: 0, unfinished: 0};
    for (const key in specials) {
      if (specials.hasOwnProperty(key)) {
        allSpecials.correctOnFirst += specials[key].correctOnFirst;
        allSpecials.correct += specials[key].correct;
        allSpecials.unfinished += specials[key].unfinished;
      }
    }
    const special = activeSpecial !== 'all' ? this.state.specials[activeSpecial] : allSpecials;
    const chartData = {
      'labels': ['Zodpovězené správně napoprvé', 'Zodpovězené správně', 'Nezodpovězené'],
      'datasets': [
        {
          data: [
            special.correctOnFirst,
            special.correct,
            special.unfinished
          ],
          backgroundColor: ['#9EE493', '#1ABB9C', '#9CC2CB']
        }
      ]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        display: false
      }
    };

    return (
      <div id="specialStats">
        <div>
          <h3>Speciály</h3>
        </div>
        {/*<div className="col-xs-12">
          <FromToDateForm
            startDate={this.state.startDate} endDate={this.state.endDate}
            handleChangeStart={this.handleChangeStart}
            handleChangeEnd={this.handleChangeEnd}
            handleSubmit={this.handleSubmit}
          />
        </div>*/}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="x-panel">
            <div className="x-title">
              <h2>Statistiky za vybrané období</h2>
              <div className="clearfix" />
            </div>
            <div className="x-content">
              <div className="row filter">
                <div className="col-xs-12 col-sm-6">
                  <ControlLabel>Vyberte speciál:</ControlLabel>
                  <FormControl componentClass="select" value={activeSpecial} onChange={this.handleChangeSpecial}>
                    <option value="all">Zobrazit vše</option>
                    {
                      specials && Object.keys(specials).map((key, index) => (
                        <option value={key} key={`special_option_${index}`}>{key}</option>
                      ))
                    }
                  </FormControl>
                </div>
                <div className="col-xs-12 col-sm-6"/>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <h5 className="graph-title">Graf</h5>
                  <Pie data={chartData} options={chartOptions} />
                </div>
                <div className="col-xs-12 col-sm-6">
                  <table className="tile-info">
                    <thead>
                    <tr>
                      <th>Speciály</th>
                      <th>Počet</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                      chartData.labels.map((label, index) =>
                        <tr key={`key_${label}`}>
                          <td>
                            <p><i className="fa fa-square"
                                  style={{ color: chartData.datasets[0].backgroundColor[index] }} />{label}</p>
                          </td>
                          <td>{chartData.datasets[0].data[index]}</td>
                        </tr>
                      )
                    }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SpecialStats;



/** WEBPACK FOOTER **
 ** ./src/containers/Statistics/SpecialStats.js
 **/